import { Link } from 'react-router-dom';

const ExperiencesPreview = () => {
  const experiences = [
    {
      id: 1,
      title: "The Great West Africa Rendezvous (GWR)",
      description: "A large-scale cultural and destination experience designed to bring West Africa together through a neutral meeting point.",
      color: "from-primary to-orange-600",
      details: [
        "Designed & owned by: MGL Experiences Ltd (UK)",
        "Executed by: Regional travel operators",
        "Focus: Culture, connection, scale, and legacy"
      ]
    },
    {
      id: 2,
      title: "Boundless Europe Experience",
      description: "A multi-country European travel format designed for group travel, diaspora engagement, and cultural immersion.",
      color: "from-secondary to-blue-600",
      details: [
        "Multi-country European travel format",
        "Diaspora & group-focused experience",
        "Licensed to approved travel operators"
      ]
    }
  ];

  return (
    <section className="bg-gray-50 py-20">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="section-title">Flagship Experiences</h2>
          <p className="section-subtitle">
            Presented as licensable intellectual property assets, not retail travel products.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {experiences.map((exp) => (
            <div key={exp.id} className="bg-white rounded-2xl shadow-xl overflow-hidden">
              <div className={`h-2 bg-gradient-to-r ${exp.color}`}></div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{exp.title}</h3>
                <p className="text-gray-600 mb-6">{exp.description}</p>
                
                <ul className="space-y-3 mb-8">
                  {exp.details.map((detail, index) => (
                    <li key={index} className="flex items-start">
                      <svg className="w-5 h-5 text-primary mt-0.5 mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                      <span className="text-gray-700">{detail}</span>
                    </li>
                  ))}
                </ul>
                
                <Link
                  to={`/experiences#${exp.title.toLowerCase().replace(/ /g, '-')}`}
                  className="inline-flex items-center text-primary font-medium hover:text-primary-dark"
                >
                  View Experience Details
                  <svg className="w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperiencesPreview;